import { useEffect } from "react";
import { SITE } from "../data/site";

const DEFAULT_IMAGE = `${SITE.domain}/assets/og-image.jpg`;

const setMeta = (attr, key, content) => {
    let el = document.head.querySelector(`meta[${attr}="${key}"]`);
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
    }
    el.setAttribute("content", content);
};

/* image: absolute or site-relative URL for link previews.
   type: Open Graph type ("website" or "article").
   jsonLd: optional structured data for this page (e.g. a BlogPosting). */
export const SEO = ({ title, description, path = "/", image, type = "website", jsonLd }) => {
    useEffect(() => {
        document.title = title;
        setMeta("name", "description", description);
        setMeta("property", "og:title", title);
        setMeta("property", "og:description", description);
        setMeta("property", "og:url", `${SITE.domain}${path}`);
        setMeta("property", "og:type", type);
        const img = image ? (image.startsWith("http") ? image : `${SITE.domain}${image}`) : DEFAULT_IMAGE;
        setMeta("property", "og:image", img);
        let canonical = document.head.querySelector('link[rel="canonical"]');
        if (!canonical) {
            canonical = document.createElement("link");
            canonical.setAttribute("rel", "canonical");
            document.head.appendChild(canonical);
        }
        canonical.setAttribute("href", `${SITE.domain}${path}`);

        const existing = document.getElementById("page-jsonld");
        if (existing) existing.remove();
        if (jsonLd) {
            const script = document.createElement("script");
            script.type = "application/ld+json";
            script.id = "page-jsonld";
            script.textContent = JSON.stringify(jsonLd);
            document.head.appendChild(script);
        }
    }, [title, description, path, image, type, jsonLd]);
    return null;
};
